import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import GAPageview from "@/components/GAPageview";
import MaintenanceGate from "@/components/MaintenanceGate";
import { Toaster } from "sonner";

// Code-split non-critical routes so the initial JS bundle only carries Home.
const Admin = lazy(() => import("@/pages/Admin"));
const Contact = lazy(() => import("@/pages/Contact"));
const About = lazy(() => import("@/pages/About"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const Disclaimer = lazy(() => import("@/pages/Disclaimer"));
const FAQ = lazy(() => import("@/pages/FAQ"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GAPageview />
        <main>
          <Suspense fallback={null}>
            <Routes>
              {/* Admin routes bypass the maintenance gate so the admin can
                  always log in and toggle maintenance mode OFF. */}
              <Route path="/lw5g-secure-panel-9421" element={<Admin />} />
              <Route path="/admin" element={<Admin />} />
              {/* All public routes are behind the maintenance gate. */}
              <Route path="/" element={<MaintenanceGate><Home /></MaintenanceGate>} />
              <Route path="/about" element={<MaintenanceGate><About /></MaintenanceGate>} />
              <Route path="/faq" element={<MaintenanceGate><FAQ /></MaintenanceGate>} />
              <Route path="/privacy" element={<MaintenanceGate><PrivacyPolicy /></MaintenanceGate>} />
              <Route path="/disclaimer" element={<MaintenanceGate><Disclaimer /></MaintenanceGate>} />
              <Route path="/contact" element={<MaintenanceGate><Contact /></MaintenanceGate>} />
            </Routes>
          </Suspense>
        </main>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
